import { config, handleResponse } from '../../_helpers';

export const inboundServices = {
    createUnLoadList,
    groupUnLoadListbyRelease,
    deleteUnLoadListByRelease,
    updateUnLoadListReleaseType,
    acknowledgeUnLoadListRelease,
    updateUnLoadList,

    getUnLoadListbyReleaseType,
    unLoadList,
    getVoyageDestination,
    getForUnloadingCreation,
    moveTallySheetToUnload,
    removeTallySheetUnLoadList,
    //tallysheet
    getUnloadListForTallySheetCreation,
    createInboundTallySheet,
    //cargo arrival notice
    inBoundUnloadingConfirmationVoyage,
    getUnLoadingConfirmationByVoyageNum,
    readcargoArrivalPerBookingRef,
    //tallysheet
    readTallySheetByVoyageNum,
    readTallySheetCode,
    deleteInBoundTallySheet,
    updateInBoundTallySheet,
    updateUnloadingTallySheetIsFinal,
    //cargo release order
    loadCRO,
    getBookingCRO,
    createInBoundCRO,
    getCRO,
    updateCRO,
    deleteCRO,
    // Cargo Delivery Receipt
    // loadCDR,
    // getBookingForCDR,
    // createCDR,
    // getCDR,
    // updateCDR,
    // deleteCDR,
    //CTS
    loadInboundCts,
    deleteInboundCTSNum,
    getCTS,
    getBookingInboundForCTS,
    getBookingInboundForCTSTandem,
    createBookingInBoundCts,
    updateInboundCTSNum,

    // Voyage List
    getVoyageArrivalNotice,
    getVoyageUnloadList,
    getVoyageUnloadTallySheet,

    // Van-In
    loadVanIn,
    getContainerVanForVanIn,
    computeInboundDemmurage,
    getVanIn,
    createVanInEmpty,
    updateVanInEmpty,
    deleteVanInEmpty,
    // new
    getInboundCtsVanDetails,
    getInboundCtsDetails,

    // Vessel Arrival Notice
    getVesselArrivalNotice,
    getVesselArrivalNoticeByVoyageNum,

    // CRO Clearance
    getVoyageCroClearance,
    getCroClearance,
    updateIsClearedCRO,
    getCroUnpaidWaybills,

    // Dispatch Module
    getDispacthList,
    updateOutDispatchList,
    sendInDispatchList,
    archiveInDispatchList,
    readArchiveInDispatchList,

    //inboundDwelltimeReport
    inboundDwelltimeReport,

    sendCANToConsigneeEmail,
}
function sendCANToConsigneeEmail(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/sendCANToConsigneeEmail`, requestOptions).then(handleResponse);
}

// inboundDwelltimeReport
 function inboundDwelltimeReport(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/inboundDwelltimeReport`, requestOptions).then(handleResponse);
}

 // Dispatch Module
function getDispacthList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/getDispacthList`, requestOptions).then(handleResponse);
}
function updateOutDispatchList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/updateOutDispatchList`, requestOptions).then(handleResponse);
}
function sendInDispatchList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/sendInDispatchList`, requestOptions).then(handleResponse);
}
function archiveInDispatchList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/archiveInDispatchList`, requestOptions).then(handleResponse);
}
function readArchiveInDispatchList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/readArchiveInDispatchList`, requestOptions).then(handleResponse);
}

function computeInboundDemmurage(load) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(load),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    
    return fetch(`${config.apiUrl}/InBound/computeInboundDemmurage`, requestOptions).then(handleResponse);
}

function getVoyageArrivalNotice(branchCode, search) {
    const requestOptions = {
        method: 'GET'
    };
    
    // return fetch(`${config.apiUrl}/InBound/getVoyageArrivalNotice?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/getVoyageArrivalNoticeListing?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // if(search){
    //     return fetch(`${config.apiUrl}/InBound/getVoyageArrivalViaNoticeListing?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/InBound/getVoyageArrivalViaNoticeListing?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/InBound/getVoyageArrivalViaNoticeListingV1?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/InBound/getVoyageArrivalViaNoticeListingV1?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    }
}
function getVoyageUnloadList(branchCode, search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(branchCode),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    
    // if(search){
    //     return fetch(`${config.apiUrl}/InBound/getVoyageListingUnloadListAssignBranch?search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/InBound/getVoyageListingUnloadListAssignBranch`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/InBound/getVoyageListingUnloadListAssignBranchV1?search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/InBound/getVoyageListingUnloadListAssignBranchV1`, requestOptions).then(handleResponse);
    }
    // const requestOptions = {
    //     method: 'GET'
    // };
    // // return fetch(`${config.apiUrl}/InBound/getVoyageUnloadList?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // if(search){
    //     return fetch(`${config.apiUrl}/InBound/getVoyageListingUnloadList?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/InBound/getVoyageListingUnloadList?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // }
}
function getVoyageUnloadTallySheet(branchCode, search) {
    const requestOptions = {
        method: 'GET'
    };
    
    // return fetch(`${config.apiUrl}/InBound/getVoyageUnloadTallySheet?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // if(search){
    //     return fetch(`${config.apiUrl}/InBound/getVoyageListingUnloadTallySheet?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/InBound/getVoyageListingUnloadTallySheet?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/InBound/getVoyageListingUnloadTallySheetV1?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/InBound/getVoyageListingUnloadTallySheetV1?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    }
}
function groupUnLoadListbyRelease(voyageNUm, branchDestination) {
    const requestOptions = {
        method: 'GET'
    };

    // return fetch(`${config.apiUrl}/InBound/groupUnLoadListbyRelease/${voyageNUm}?userBranch=${branchDestination}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/groupUnLoadListbyReleaseV1/${voyageNUm}?userBranch=${branchDestination}`, requestOptions).then(handleResponse);
}
function createUnLoadList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/createUnLoadList`, requestOptions).then(handleResponse);
}
function updateUnLoadListReleaseType(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/InBound/updateUnLoadListReleaseType`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/updateUnLoadListReleaseTypeV1`, requestOptions).then(handleResponse);
}
function deleteUnLoadListByRelease(payload) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/deleteUnLoadListByRelease`, requestOptions).then(handleResponse);
}
function getUnLoadListbyReleaseType(voyageNUm, releaseNum, destination, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/InBound/getUnLoadListbyReleaseType/${voyageNUm}?ReleaseId=${releaseNum}&userBranch=${destination}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/InBound/getUnLoadListbyReleaseType/${voyageNUm}?ReleaseId=${releaseNum}&userBranch=${destination}`, requestOptions).then(handleResponse);
    }
}
function acknowledgeUnLoadListRelease(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/acknowledgeUnLoadListRelease`, requestOptions).then(handleResponse);
}
function updateUnLoadList(payload, releaseId) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/updateUnLoadList/${releaseId}`, requestOptions).then(handleResponse);
}
function unLoadList(voyageNUm, destinationBranchCode) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/InBound/UnLoadList/${voyageNUm}?destinationBranchCode=${destinationBranchCode}`, requestOptions).then(handleResponse);
}
function getVoyageDestination(voyageNUm) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/InBound/getVoyageDestination/${voyageNUm}`, requestOptions).then(handleResponse);
}
function getForUnloadingCreation(voyageNUm, destinationBranchCode) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/InBound/getForUnloadingCreation/${voyageNUm}?destinationBranchCode=${destinationBranchCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/getForUnloadingCreationWithVia/${voyageNUm}?destinationBranchCode=${destinationBranchCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/getForUnloadingCreationWithVia1/${voyageNUm}?destinationBranchCode=${destinationBranchCode}`, requestOptions).then(handleResponse);
}
function moveTallySheetToUnload(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/moveTallySheetToUnload`, requestOptions).then(handleResponse);
}
function removeTallySheetUnLoadList(voyageNum, releaseNum, branchDestination) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify({ voyageNum, releaseNum, branchDestination }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/removeTallySheetUnLoadList`, requestOptions).then(handleResponse);
}
function getUnloadListForTallySheetCreation(voyageNUm, destinationBranchCode) {
// function getUnloadListForTallySheetCreation(voyageNUm) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/InBound/getUnloadListForTallySheetCreation/${voyageNUm}?userBranch=${destinationBranchCode}`, requestOptions).then(handleResponse);    
    return fetch(`${config.apiUrl}/InBound/getUnloadListForTallySheetCreationByVoyageNum/${voyageNUm}?userBranch=${destinationBranchCode}`, requestOptions).then(handleResponse);    
    // return fetch(`${config.apiUrl}/InBound/getUnloadListForTallySheetCreationByVoyageNum/${voyageNUm}`, requestOptions).then(handleResponse);
}
function createInboundTallySheet(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/InBound/createInboundTallySheet`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/createInboundTallySheet1`, requestOptions).then(handleResponse);
}
function inBoundUnloadingConfirmationVoyage(branchCode) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/InBound/inBoundUnloadingConfirmationVoyage?branchCode=${branchCode}`, requestOptions).then(handleResponse);
}
function getUnLoadingConfirmationByVoyageNum(voyageNUm, voyageDestbranchCode) {
    const requestOptions = {
        method: 'GET'
    };
    //     return fetch(`${config.apiUrl}/InBound/getUnLoadingConfirmationByVoyageNum/${voyageNUm}?voyageDestbranchCode=${voyageDestbranchCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/getTallysheetUnLoadingConfirmationByVoyageNum/${voyageNUm}?voyageDestbranchCode=${voyageDestbranchCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/getTallysheetUnloadingConfirmationByVoyageVia/${voyageNUm}?voyageDestbranchCode=${voyageDestbranchCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/cargoArrivalNoticePerVoyage/${voyageNUm}?voyageDestbranchCode=${voyageDestbranchCode}`, requestOptions).then(handleResponse);
}
function readcargoArrivalPerBookingRef(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/readcargoArrivalPerBookingRef`, requestOptions).then(handleResponse);
}
function readTallySheetByVoyageNum(voyageNUm, branchCode) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/InBound/readTallySheetByVoyageNum/${voyageNUm}?userBranch=${branchCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/readTallySheetByVoyageNumVia/${voyageNUm}?userBranch=${branchCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/readTallySheetByVoyageNumViaV1/${voyageNUm}?userBranch=${branchCode}`, requestOptions).then(handleResponse);
}
function readTallySheetCode(tallysheetCode) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/InBound/readTallySheetCode/${tallysheetCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/readTallySheetCodeV1/${tallysheetCode}`, requestOptions).then(handleResponse);
}
function deleteInBoundTallySheet(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/deleteUnloadedTallySheet`, requestOptions).then(handleResponse);
}
function updateInBoundTallySheet(tallysheetCode, payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };    
    // return fetch(`${config.apiUrl}/InBound/updateInBoundTallySheet/${tallysheetCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/updateInBoundTallySheet1/${tallysheetCode}`, requestOptions).then(handleResponse);
}
function updateUnloadingTallySheetIsFinal(tallysheetCode, payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/updateUnloadingTallySheetIsFinal/${tallysheetCode}`, requestOptions).then(handleResponse);
}
// CRO
function loadCRO(skip, take, filter, search, userBranch) {
    const requestOptions = {
        method: 'GET'
    };
    
    // if (filter && search) {
    //     if (userBranch) return fetch(`${config.apiUrl}/InBound/loadCRO?skip=${skip}&take=${take}&filter=${filter}&search=${search}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
    //     else return fetch(`${config.apiUrl}/InBound/loadCRO?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    // } else {
    //     if (userBranch) return fetch(`${config.apiUrl}/InBound/loadCRO?skip=${skip}&take=${take}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
    //     else return fetch(`${config.apiUrl}/InBound/loadCRO?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    // }
    if (filter && search) {
        if (userBranch) return fetch(`${config.apiUrl}/InBound/loadCROV1?skip=${skip}&take=${take}&filter=${filter}&search=${search}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
        else return fetch(`${config.apiUrl}/InBound/loadCROV1?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        if (userBranch) return fetch(`${config.apiUrl}/InBound/loadCROV1?skip=${skip}&take=${take}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
        else return fetch(`${config.apiUrl}/InBound/loadCROV1?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getBookingCRO(croByBooking, branch) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/InBound/getBookingCRO/${croByBooking}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/getBookingCROV1/${croByBooking}?userBranch=${branch}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/getBookingCROV2/${croByBooking}?userBranch=${branch}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/getBookingCROV3/${croByBooking}?userBranch=${branch}`, requestOptions).then(handleResponse);
    
}
function createInBoundCRO(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/InBound/createInBoundCRO`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/createInBoundCROV1`, requestOptions).then(handleResponse);
}
function getCRO(cargorReleaseOrderId) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/InBound/getCRO/${cargorReleaseOrderId}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/getCROV1/${cargorReleaseOrderId}`, requestOptions).then(handleResponse);
}
function updateCRO(cargorReleaseOrderId, payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/updateCRO/${cargorReleaseOrderId}`, requestOptions).then(handleResponse);
}
function deleteCRO(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/deleteCRO`, requestOptions).then(handleResponse);
}
// function loadCDR(skip, take, filter, search, userBranch) {
//     const requestOptions = {
//         method: 'GET'
//     };
//     if (filter && search) {
//         if (userBranch) return fetch(`${config.apiUrl}/InBound/loadCDR?skip=${skip}&take=${take}&filter=${filter}&search=${search}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
//         else return fetch(`${config.apiUrl}/InBound/loadCDR?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
//     } else {
//         if (userBranch) return fetch(`${config.apiUrl}/InBound/loadCDR?skip=${skip}&take=${take}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
//         else return fetch(`${config.apiUrl}/InBound/loadCDR?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
//     }
// }
// function getBookingForCDR(bookingRef) {
//     const requestOptions = {
//         method: 'GET'
//     };
//     return fetch(`${config.apiUrl}/InBound/getBookingForCDR/${bookingRef}`, requestOptions).then(handleResponse);
// }
// function createCDR(payload) {
//     const requestOptions = {
//         method: 'POST',
//         body: JSON.stringify(payload),
//         headers: {
//             "Content-type": "application/json; charset=UTF-8"
//         }
//     };
//     return fetch(`${config.apiUrl}/InBound/createInBoundCDR`, requestOptions).then(handleResponse);
// }
// function getCDR(cdrId) {
//     const requestOptions = {
//         method: 'GET'
//     };
//     return fetch(`${config.apiUrl}/InBound/getCDR/${cdrId}`, requestOptions).then(handleResponse);
// }
// function updateCDR(cdrId, payload) {
//     const requestOptions = {
//         method: 'PUT',
//         body: JSON.stringify(payload),
//         headers: {
//             "Content-type": "application/json; charset=UTF-8"
//         }
//     };
//     return fetch(`${config.apiUrl}/InBound/updateCDR/${cdrId}`, requestOptions).then(handleResponse);
// }
// function deleteCDR(id) {
//     const requestOptions = {
//         method: 'DELETE',
//         body: JSON.stringify(id),
//         headers: {
//             "Content-type": "application/json; charset=UTF-8"
//         }
//     };
//     return fetch(`${config.apiUrl}/InBound/deleteCDR`, requestOptions).then(handleResponse);
// }
function loadInboundCts(skip, take, filter, search, userBranch) {
    const requestOptions = {
        method: 'GET'
    };
    // if (filter && search) {
    //     if (userBranch) return fetch(`${config.apiUrl}/InBound/loadInboundCts?skip=${skip}&take=${take}&filter=${filter}&search=${search}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
    //     else return fetch(`${config.apiUrl}/InBound/loadInboundCts?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    // } else {
    //     if (userBranch) return fetch(`${config.apiUrl}/InBound/loadInboundCts?skip=${skip}&take=${take}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
    //     else return fetch(`${config.apiUrl}/InBound/loadInboundCts?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    // }
    if (filter && search) {
        if (userBranch) return fetch(`${config.apiUrl}/InBound/loadInboundCtsV1?skip=${skip}&take=${take}&filter=${filter}&search=${search}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
        else return fetch(`${config.apiUrl}/InBound/loadInboundCtsV1?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        if (userBranch) return fetch(`${config.apiUrl}/InBound/loadInboundCtsV1?skip=${skip}&take=${take}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
        else return fetch(`${config.apiUrl}/InBound/loadInboundCtsV1?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function deleteInboundCTSNum(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/deleteInboundCTSNum`, requestOptions).then(handleResponse);
}
function getCTS(CtsNum) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/InBound/getCTS/${CtsNum}`, requestOptions).then(handleResponse);
}
function getBookingInboundForCTS(bookingRef, branch) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/InBound/getBookingInboundForCTS/${bookingRef}?userBranch=${branch}`, requestOptions).then(handleResponse);
}
function getBookingInboundForCTSTandem(bookingRef, branch) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/InBound/getBookingInboundForCTS/${bookingRef}?userBranch=${branch}`, requestOptions).then(handleResponse);
}
function createBookingInBoundCts(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/InBound/createBookingInBoundCts`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/createBookingInBoundCtsWithStorage`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/createInBoundCtsDamageParts`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/createInBoundCtsDamagePartsV1`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/createInBoundCtsDamagePartsV2`, requestOptions).then(handleResponse);
}
function updateInboundCTSNum(payload, CtsNum) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/InBound/updateInboundCTSNum/${CtsNum}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/updateInboundCTSDamageParts/${CtsNum}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/updateInboundCTSDamagePartsV1/${CtsNum}`, requestOptions).then(handleResponse);
}
// Van-In
function loadVanIn(skip, take, search, userBranch) {
    const requestOptions = {
        method: 'GET'
    };
    // if (search) {
    //     return fetch(`${config.apiUrl}/InBound/loadVanIn?skip=${skip}&take=${take}&search=${search}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
    // }
    // else {
    //     return fetch(`${config.apiUrl}/InBound/loadVanIn?skip=${skip}&take=${take}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
    // }
    if (search) {
        return fetch(`${config.apiUrl}/InBound/loadVanInInputDetails?skip=${skip}&take=${take}&search=${search}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/InBound/loadVanInInputDetails?skip=${skip}&take=${take}&userBranch=${userBranch}`, requestOptions).then(handleResponse);
    }

}
function getContainerVanForVanIn() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/InBound/getContainerVanForVanIn`, requestOptions).then(handleResponse);
}
function getVanIn(vanInId) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/InBound/getVanIn/${vanInId}`, requestOptions).then(handleResponse);
    //  return fetch(`${config.apiUrl}/InBound/getVanInInputDetails/${vanInId}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/getVanInInputDetailsV1/${vanInId}`, requestOptions).then(handleResponse);
}
function getInboundCtsVanDetails(branch, search) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/InBound/getInboundCtsVanDetails/${branch}?search=${search}`, requestOptions).then(handleResponse);
}
function getInboundCtsDetails(ctsNum, branch) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/InBound/getInboundCtsDetails/${ctsNum}?userBranch=${branch}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/getInboundCtsDetailsIsShipperOwn/${ctsNum}?userBranch=${branch}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/getInboundCtsDetailsIsShipperOwnV1/${ctsNum}?userBranch=${branch}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/getInboundCtsDetailsIsShipperOwnV2/${ctsNum}?userBranch=${branch}`, requestOptions).then(handleResponse);
}
function createVanInEmpty(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/InBound/createVanIn`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/createVanInInputDetails`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/createVanInDamageParts`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/createVanInDamagePartsV1`, requestOptions).then(handleResponse);
}
// function updateVanInEmpty(payload, id) {
function updateVanInEmpty(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/InBound/updateVanIn/${id}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/updateVanIninputDetails/${id}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/updateVanInDamageParts/${id}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/updateVanInDamagePartsV1`, requestOptions).then(handleResponse);
}
function deleteVanInEmpty(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/InBound/deleteVanInEmpty`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/InBound/deleteVanIn`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/deleteVanInV1`, requestOptions).then(handleResponse);
}
// Vessel Arrival Notice
function getVesselArrivalNotice(branchCode, search) {
    const requestOptions = {
        method: 'GET'
    };
    
    // return fetch(`${config.apiUrl}/InBound/getVesselArrivalNotice?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // if(search){
    //     return fetch(`${config.apiUrl}/InBound/getVesselListingArrivalNotice?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/InBound/getVesselListingArrivalNotice?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/InBound/getVesselListingArrivalNoticeV1?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/InBound/getVesselListingArrivalNoticeV1?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    }
}
function getVesselArrivalNoticeByVoyageNum(voyageNUm, destinationBranchCode) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/InBound/getVesselArrivalNoticeByVoyageNum/${voyageNUm}?voyageDestbranchCode=${destinationBranchCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/getVesselArrivalNoticeByVoyageNumV1/${voyageNUm}?voyageDestbranchCode=${destinationBranchCode}`, requestOptions).then(handleResponse);
}
// CRO Clearance
function getVoyageCroClearance(search) {
    const requestOptions = {
        method: 'GET'
    };
    
    // return fetch(`${config.apiUrl}/InBound/getVoyageCRO`, requestOptions).then(handleResponse);
    // if(search){
    //     return fetch(`${config.apiUrl}/InBound/getVoyageCROClearance?search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/InBound/getVoyageCROClearance`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/InBound/getVoyageCROClearanceV1?search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/InBound/getVoyageCROClearanceV1`, requestOptions).then(handleResponse);
    }
}
function getCroClearance(voyageNum, branch) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/InBound/getBookingForCroByVoyageNum/${voyageNum}?userBranch=${branch}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/getBookingForCroByVoyageNumV1/${voyageNum}?userBranch=${branch}`, requestOptions).then(handleResponse);
}
// function updateIsClearedCRO(voyageNum, payload) {
//     const requestOptions = {
//         method: 'PUT',
//         body: JSON.stringify(payload),
//         headers: {
//             "Content-type": "application/json; charset=UTF-8"
//         }
//     };
//     return fetch(`${config.apiUrl}/InBound/updateIsClearedCRO/${voyageNum}`, requestOptions).then(handleResponse);
// }
function updateIsClearedCRO(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/InBound/CleareCRO`, requestOptions).then(handleResponse);
}
function getCroUnpaidWaybills(Waybills) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(Waybills),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/InBound/getCroUnpaidWaybills`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/InBound/getCroUnpaidWaybillsV1`, requestOptions).then(handleResponse);
}